import { Avatar, Badge, Stack, SxProps, Theme, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import { AddonCrown16C } from '@/assets';
import { globalEnums } from '@/shared/duck';
import { muiPalette } from '@/shared/general-theme';

import { setAvatarStyle } from './duck';

interface UserAvatarProps {
  fullName?: string;
  withFullNameText?: boolean;
  roles: globalEnums.ERoles[];
  src?: string | null;
  theme?: Theme & ('primary' | 'secondary');
  avatarSize?: number;
  description?: string,
  sx?: SxProps<Theme>;
  cursorPointer?: boolean;
  isAdmin?: boolean;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  fullName = '',
  withFullNameText = false,
  src = '',
  avatarSize = 2.5,
  cursorPointer = false,
  description,
  // roles,
  isAdmin = false,
  ...props
}) => {
  const decodedSrc = useMemo(() => {
    return src ? decodeURIComponent(src) : '';
  }, [src]);

  return (
    <Stack
      gap='1rem'
      flexDirection='row'
      alignItems='center'
      sx={{ cursor: cursorPointer ? 'pointer' : 'default', mt: '0.5rem', ...props.sx }}
      {...props}
    >
      {isAdmin ? (
        <Badge
          badgeContent={<AddonCrown16C sx={{ transform: 'rotate(45deg)' }} />}
        >
          <Avatar
            {...setAvatarStyle(avatarSize, fullName)}
            src={decodedSrc}
            alt={fullName}
          />
        </Badge>
      ) : (
        <Avatar
          {...setAvatarStyle(avatarSize, fullName)}
          src={decodedSrc}
          alt={fullName}
        />
      )}

      {withFullNameText && fullName && (
        <Stack gap={0}>
          <Typography variant={'subtitle2'} sx={{ fontWeight: 'bold' }}>
            {fullName}
          </Typography>

          {description && (
            <Typography
              variant={'caption'}
              color={muiPalette.text.secondary}
            >
              {description}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default UserAvatar;